export default [
    '1031-Buyer',
    'Active',
];